import { render, staticRenderFns } from "./testresult.vue?vue&type=template&id=678d7de1&scoped=true"
import script from "./testresult.vue?vue&type=script&lang=ts"
export * from "./testresult.vue?vue&type=script&lang=ts"
import style0 from "./testresult.vue?vue&type=style&index=0&id=678d7de1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d7de1",
  null
  
)

export default component.exports